/*
 * Copyright © 2024 Himitsu Lab Limited. All Rights Reserved.
 */

import { useMemo } from 'react';
import {UserPolicyAgreements} from '../models/userPolicyAgreements.model';
import {useGetAllPoliciesQuery, useGetEventCreationPolicyQuery} from '../Services/policyApi';
import {useAgreeEventPolicyMutation} from '../Services/userPolicyAgreementsApi';

/**
 * Custom hook to manage event policy agreements.
 *
 * @return {Object} An object containing event policies, agreement status, an agree function, and policy success status.
 */

export const useEventPolicyAgreementHooks = () => {
  const {data: policies, isSuccess: policiesSuccess} =
    useGetEventCreationPolicyQuery();
  const [agreeEventPolicy, {isSuccess: eventPolicyAgreed}] =
    useAgreeEventPolicyMutation();
  const { data: activePolicyData, isSuccess: activePolicyDataSuccess } = useGetAllPoliciesQuery();

  const policyOrder = ["P03", "P01"];

  const filteredPolicies = useMemo(() => (
    activePolicyData?.filter(policy => policyOrder.includes(policy.policyId))
      .sort((a, b) => policyOrder.indexOf(a.policyId) - policyOrder.indexOf(b.policyId)) || []
  ), [activePolicyData]);
  
  
  const agree = () => {
    const userPolicy = {} as UserPolicyAgreements;
    userPolicy.policies = policies;
    agreeEventPolicy(userPolicy);
  };

  return {
    policies,
    eventPolicyAgreed,
    filteredPolicies,
    agree,
    policiesSuccess,
  };
};
